const steps = [
    {id: 1, title: 'About 3D Secure 2.2', name: 'about'},
    {id: 2, title: 'Building Your 3-D Secure 2.2 Integration', name: 'building'},
    {id: 3, title: 'Implementing Card Lookup Request', name: 'card_lookup'},
    {id: 4, title: 'Implementing MPI 3DS Authentication Request', name: '3ds_auth'},
    {id: 5, title: 'Handling the Challenge Flow', name: 'handling_challenge'},
    {id: 6, title: 'Handling the Decoupled Authentication Flow', name: 'handling_decoupled'},
    {id: 7, title: 'Performing the Authorization', name: 'performing_auth'},

    {id: 8, title: 'Purchase with 3-D Secure', name: 'cavv_purchase'},
    {id: 9, title: 'Pre-Authorization with 3-D Secure', name: 'cavv_preauth'},
    {id: 10, title: 'Purchase with Vault and 3-D Secure', name: 'cavv_purchase_v'},
    {id: 11, title: 'Pre-Authorization with Vault & 3-D Secure', name: 'cavv_preauth_v'},
    {id: 12, title: 'Purchase with 3-D Secure and Recurring Billing', name: 'cavv_purchase_rec'},

    {id: 16, title: 'Cavv Purchase – Apple Pay and Google Pay™', name: 'cavv_purchase_apple_google'},
    {id: 17, title: 'Cavv Pre-Authorization – Apple Pay & Google Pay™', name: 'cavv_preauth_apple_google'},
    {id: 18, title: 'GooglePay Temporary Token Add', name: 'google_temp_token'},
    {id: 19, title: 'Google Pay™ Token Preauth', name: 'google_token_preauth'},
    {id: 20, title: 'Google Pay™ Token Purchase', name: 'google_token_purchase'},

    {id: 13, title: 'Testing your 3-D Secure 2.2 integration', name: 'testing'},
    {id: 14, title: 'Moving to production with 3-D Secure 2.2', name: 'production'},
    {id: 15, title: 'References', name: 'reference'}
]

export default steps